import React, { useRef, useState } from 'react';
import './userProfile.scss';
import useOnClickOutside from "../../../hooks/useOnClickOutside";
import LoggedInUserDropdown from "./userProfileMenu/LoggedInUserProfileMenu";
import AnonymousUserDropdown from './userProfileMenu/AnonymousUserProfileMenu';

const UserProfile = ({ menuOptions, user, userProfileImageUrl, loginUrl, anonymousUserIcon }) => {
  const [showMenu, setShowMenu] = useState(false);
  const userProfileRef = useRef(null);

  function toggleMenu() {
    setShowMenu(!showMenu);
  }

  useOnClickOutside(userProfileRef, () => {
    setShowMenu(false);
  });

  const profilePicture = user && user.$$attachments != null && user?.$$attachments?.find((att) => (att.$$expanded.type === 'PROFILE_IMAGE' && att.$$expanded.width === 128));

  return (
    <nav className="user-profile" ref={userProfileRef}>
      <ul>
        <li>
          <div data-testid="user-profile-circle" className="user-profile-circle" onClick={toggleMenu}>
            <div className="text-circle">
              {profilePicture ? (
                <div className="user-image" style={{ backgroundImage: `url(${userProfileImageUrl})` }}></div>
              ) : (
                <span data-testid="user-initials">{user?.initials || '?'}</span>
              )}
            </div>
            {showMenu && user && <LoggedInUserDropdown user={user} menuOptions={menuOptions} />}
            {showMenu && !user && (
              <AnonymousUserDropdown loginUrl={loginUrl} AnonymousUserIcon={anonymousUserIcon} />
            )}
          </div>
        </li>
      </ul>
    </nav>
  );
}

export default UserProfile;